import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import {ItemTypes} from '../../constants'
import SortContainer from '../SortContainer'

class PartDefinitionItem extends Component {
  static propTypes = {
    partDefinition: PropTypes.object.isRequired,
    locals: PropTypes.object.isRequired
  }

  state = {
    selected: false
  }

  componentDidMount () {
    // if (!this.props.partDefinition.id) {
    //   this.setState({selected: true})
    // }
  }

  toggleFields = e => {
    e.preventDefault()
    this.setState({selected: !this.state.selected})
  }

  render () {
    const {connectDragSource, connectDragPreview, isDragging,
      partDefinition, locals} = this.props
    const {selected} = this.state

    return connectDragPreview(
      <div className={cn('part-definition', {placeholder: isDragging})}>
        <div className={cn('header', {selected})} onClick={this.toggleFields}>
          {connectDragSource(<span className='handle' />)}
          <span className='part-name'>{partDefinition.label}</span>
          <span className='part-type'>{partDefinition.type}</span>
        </div>
        <div className='fields'>{locals.input}</div>
        <button type='button' className='part-remove' onClick={locals.buttons[0].click} />
      </div>
    )
  }
}

export default class PartDefinitionList extends Component {
  static propTypes = {
    locals: PropTypes.object.isRequired
  }

  itemKeys () {
    return this.props.locals.items.map(item => item.key)
  }

  didSort = (items) => {
    const value = items.slice().map((item, i) => {
      item.partDefinition.display_order = i
      return item.partDefinition
    })

    const keys = items.slice().map((item, i) => {
      return item
    })

    this.props.locals.onChange(value, keys, this.props.locals.path, 'move')
  }

  renderItem = ({partDefinition, item}) => {
    return <PartDefinitionItem partDefinition={partDefinition} locals={item} />
  }

  render () {
    const {items, add} = this.props.locals
    const value = this.props.locals.value
      .filter((partDefinition, index) => items[index])
      .map((partDefinition, index) => {
        const item = items[index]
        const id = partDefinition.id || null
        return {id, partDefinition, item}
      })

    return <div className='part-list'>
      <label className='control-label'>Parts</label>
      <SortContainer
        itemType={ItemTypes.PART_DEFINITION}
        items={value}
        didSort={this.didSort}
        renderItem={this.renderItem}
      />
      <button type='button' className='btn' onClick={add.click}>Add</button>
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/PartDefinitionList.js